import { find, findAll } from "../utils/dom";
import gsap from "gsap";
import Swiper from "swiper";

const PageExposicoesTemporariasSingle = () =>{
	const page = find("[js-page='exposicoes-temporarias-single']");
	if(!page) return;



	const $ = {
		Informacao: findAll('[js-curadoria]'),
		ModalInformacao: find(`[js-modal="curadoria"]`)
	}


	$.Informacao?.forEach((info)=>{
		info.addEventListener("click", (e)=>{

			const modalInfo = {
				nome: $.ModalInformacao.querySelector("[js-nome-curadoria]"),
				imagem: $.ModalInformacao.querySelector("[js-imagem-curadoria]"),
				descricao: $.ModalInformacao.querySelector("[js-descricao-curadoria]"),
				cargo: $.ModalInformacao.querySelector("[js-cargo-curadoria]")
			}

			const atualInfo = {
				nome: e.target.getAttribute('js-nome'),
				imagem: e.target.getAttribute('js-foto'),
				descricao: e.target.getAttribute('js-descricao'),
				cargo: e.target.getAttribute('js-cargo')
			}

			modalInfo.nome.textContent = atualInfo.nome;
			modalInfo.imagem.src = atualInfo.imagem;
			modalInfo.descricao.textContent = atualInfo.descricao;
			if(atualInfo.cargo && atualInfo.cargo != 'None'){
				modalInfo.cargo.textContent = atualInfo.cargo;
			}

		})
	})


	const tl = gsap.timeline({
		scrollTrigger: {
			scrub: 1,
			pin: true,
			trigger: "#item-fixed",
			start: "50% 50%",
			endTrigger: "#content",
			end: "bottom 100%",
		},
	});

	const SwiperGaleria = new Swiper(".swiper-galeria",{
		spaceBetween: 20,
		slidesPerView: 'auto',
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints:{
			767:{
				spaceBetween: 32,
				pagination:{
					dynamicBullets: false
				}
			}
		}
	})
}

export default PageExposicoesTemporariasSingle;